import AxiosInstance from "../Utils/axios/axiosConfig";

//All Services for Roles & Permissions

export const getAllRoles = async (source= undefined) => {
    let response;
    if(source)
        response = await AxiosInstance.get("/deckle-role/",{cancelToken: source.token});
    else
        response = await AxiosInstance.get("/deckle-role/");
    if(!response.data.error)
        return response.data.data;
    else
        return Promise.reject(response)
}

export const getRole = async (role,source = undefined) =>{
    let response;
    if(source)
        response = await AxiosInstance.get(`/deckle-role/?name=${role}`,{cancelToken:source.token});
    else
        response = await AxiosInstance.get(`/deckle-role/?name=${role}`);
    if(!response.data.error)
        return response.data.data;
    else
        return Promise.reject(response);
}

export const addRole = async (body) => {
    let response = await AxiosInstance.post("/deckle-role/",body);
    if(!response.data.error)
        return response.data;
    else
        return Promise.reject(response);
}

export const editRole = async (role,body) => {
    let response = await AxiosInstance.put(`/deckle-role/?name=${role}`,body);
    if(!response.data.error)
        return response.data;
    else
        return Promise.reject(response);
}

export const deleteRole = async (role) => {
    let response = await AxiosInstance.delete(`/deckle-role/?name=${role}`);
    if(!response.data.error)
        return response.data;
    else
        return Promise.reject(response);
}

//All Services for Custom alerts

export const getAllCustomAlert = async(start, end, sort_by, sort_type)=>{    
    let response = await AxiosInstance.get(`/custom-alerts/?start=${start}&end=${end}`);
    if(!response.data.error)
        return response.data.data;
    else
        return Promise.reject(response);
}

export const addCustomAlert = async (body) => {
    let response = await AxiosInstance.post("/custom-alerts/",body);
    if(!response.data.error)
        return response.data;
    else
        return Promise.reject(response);
}

export const getAlertsById = async (id) => {
    let response = await AxiosInstance.get(`/custom-alerts/?id=${id}`);
    if(!response.data.error)
        return response.data.data;
    else
        return Promise.reject(response);
}

export const editCustomAlert = async (id,body) => {
    let response = await AxiosInstance.put(`/custom-alerts/?id=${id}`,body);
    if(!response.data.error)
        return response.data;
    else
        return Promise.reject(response);
}

export const deleteCustomAlert = async (id) => {
    let response = await AxiosInstance.delete(`/custom-alerts/?id=${id}`);
    if(!response.data.error)
        return response.data;
    else
        return Promise.reject(response);
}

//All Services for Notifications

export const getAllNotifications = async (start, end, type) => {
  let response;
  if (type)
    response = await AxiosInstance.get(
      `/notifications/?type=${type}&start=${start}&end=${end}`
    );
  else if (start && end)
    response = await AxiosInstance.get(
      `/notifications/?start=${start}&end=${end}`
    );
  else response = await AxiosInstance.get("/notifications/");
  if (!response.data.error) return response.data.data;
  else return Promise.reject(response);
};

export const editNotification = async (id, body) => {
  let response = await AxiosInstance.put(`/notifications/?id=${id}`, body);
  if (!response.data.error) return response.data;
  else return Promise.reject(response);
};

export const editAllNotification = async () => {
  let response = await AxiosInstance.put("/notifications/");
  if (!response.data.error) return response.data;
  else return Promise.reject(response);
};